import axios from 'axios';
// import _ from 'lodash'
import {
  GET_INS_TEAMS_LIST,
  GET_INS_TEAMS_LIST_SUCCESS,
  GET_INS_TEAMS_LIST_FAIL,

  GET_TEAMS_INS_LIST,
  GET_TEAMS_INS_LIST_SUCCESS,
  GET_TEAMS_INS_LIST_FAIL,

  TEAM_STAFF,
  TEAM_STAFF_SUCCESS,
  TEAM_STAFF_FAIL,

  ADD_TEAM,
  RENAME_TEAM,
  DELETS_TEAM,
  EDIT_TEAM,
  EDIT_TEAM_STATE,
  EDIT_TEAM_SUCCESS,
  EDIT_TEAM_FAIL,
  EPMTY_EDITING_DATA,
  MERGE_TEAM,

  TEAM_BYID,
  TEAM_BYID_SUCCESS,
  TEAM_BYID_FAIL,

  MESH_TYPE,
  JOBS_UPLOAD_SUCCESS,
  JOBS_UPLOAD_SUCCESS_AUTOREFRESH,

  UPDATE_SENSOR_ID,
  UPDATE_PLAYER_STATUS,
  DELETE_PLAYERS,
  EDIT_PLAYER,
  EDIT_PLAYER_STATE,
  EDIT_PLAYER_SUCCESS,
  EDIT_PLAYER_FAIL,
  EPMTY_EDITING_PLAYERS_DATA,
  UPDATE_ALL_PLAYER_STATUS,

  GET_TEAM_STAT_SUMMARY,
  GET_TEAM_STAT_SUMMARY_SUCCESS,
  GET_TEAM_STAT_SUMMARY_FAIL,

  FETCH_TEAM_MEMBERS,
  FETCH_TEAM_MEMBERS_SUCCESS,
  FETCH_TEAM_MEMBERS_FAIL,

  REMOVE_TEAM_MEMBERS,
  REMOVE_TEAM_MEMBERS_SUCC,
  REMOVE_TEAM_MEMBERS_FAIL,

  SET_TEAM_ANYLSIS_DATA,
  INSTANCE_TYPE,
  MESH_SUBTYPE,
  SAVE_VTU,
  EXCLUDE_SIMULATIONS,
  EXIST_SIMULATIONS,

  SET_TEAM_MPS_DATA,

  GET_ALL_SIMULATIONS_MPS_SUCC,
  GET_ALL_SIMULATIONS_MPS,
  GET_ALL_SIMULATIONS_MPS_FAIL,

  GET_TEAM_SIMULATIONS,
  GET_TEAM_SIMULATIONS_SUCCESS,
  GET_TEAM_SIMULATIONS_FAIL,
  GET_SIMS_LOG,
  SIMS_LOG_SUCCESS,
  SIMS_LOG_FAIL,
  RESET_TEAM_SIMULATIONS,

  GET_TEAMS_LIST,
  GET_TEAMS_LIST_SUCCESS,
  GET_TEAMS_LIST_FAIL,
  CHANGE_ADMIN_TO_PLAYER,
  DELETE_UNDEFINED_MEM_FAIL,
  DELETE_UNDEFINED_MEM_STATE,
  DELETE_UNDEFINED_MEM_LOADER,
  DELETE_TEAM_STAFF_STATE,
  DELETE_TEAM_STAFF_FAIL,
  DELETE_TEAM_STAFF_LOADER,
  DELETE_TEAM_STAFF_AFTER_SUCC,

  ML_TRAINING_RESULT_GET,
  ML_TRAINING_RESULT,
  ML_TRAINING_RESULT_FAIL,

  GET_TEAM_BRAIN_IMAGE,
  GET_TEAM_BRAIN_IMAGE_SUCCESS,
  GET_TEAM_BRAIN_IMAGE_FAIL,

  // GET_OPTIMIZED_DATA,
  // GET_OPTIMIZED_DATA_SUCCESS,
  // GET_OPTIMIZED_DATA_FAIL,

  //top 20
  // FETCH_TEAM_TOP_30_DATA,
  // FETCH_TEAM_TOP_30_DATA_SUCCESS,
  // FETCH_TEAM_TOP_30_DATA_FAIL,

  //STRAIN
  GET_ALL_PLAYER_ANALYSIS_DATA,
  GET_ALL_PLAYER_ANALYSIS_DATA_SUCCESS,
  GET_ALL_PLAYER_ANALYSIS_DATA_FAIL,

  //STRAIN
  // GET_ALL_PLAYER_ANALYSIS_DATA_PRESSURE,
  // GET_ALL_PLAYER_ANALYSIS_DATA_PRESSURE_SUCCESS,
  // GET_ALL_PLAYER_ANALYSIS_DATA_PRESSURE_FAIL,

  //ML
  GET_ALL_PLAYER_ML_ANALYSIS_DATA,
  GET_ALL_PLAYER_ML_ANALYSIS_DATA_SUCCESS,
  GET_ALL_PLAYER_ML_ANALYSIS_DATA_FAIL,

  //PRESSURE
  GET_ALL_PLAYER_PRESSURE_ANALYSIS_DATA,
  GET_ALL_PLAYER_PRESSURE_ANALYSIS_DATA_SUCCESS,
  GET_ALL_PLAYER_PRESSURE_ANALYSIS_DATA_FAIL,

  //TEAM SENSORS
  FETCH_TEAMS_SENSORS,
  FETCH_TEAMS_SENSORS_SUCCESS,
  FETCH_TEAMS_SENSORS_FAIL,
  FETCH_BRAIN_LOAD_OVER_TIME,
  FETCH_BRAIN_LOAD_OVER_TIME_SUCCESS,
  FETCH_BRAIN_LOAD_OVER_TIME_FAIL,
  FETCH_ASSESMENT_SCORE,
  FETCH_ASSESMENT_SCORE_SUCCESS,
  FETCH_ASSESMENT_SCORE_FAIL,

  FETCH_ALL_TEAMS,
  FETCH_ALL_TEAMS_SUCCESS,
  FETCH_ALL_TEAMS_FAIL,

  FETCH_MPS_DATA_ANALYTICS,
  FETCH_MPS_DATA_ANALYTICS_SUCCESS,
  FETCH_MPS_DATA_ANALYTICS_FAIL
} from "./actionTypes"
import { LOGOUT_LOGGEDIN_USER } from "../auth/login/actionTypes";

//fetching ml training results
// Delete team members
const fetchMltraningRes = () => ({
  type: ML_TRAINING_RESULT_GET
})

const fetchMltraningResSuccess = items => ({
  type: ML_TRAINING_RESULT,
  payload: items,
})

const fetchMltraningResFail = error => ({
  type: ML_TRAINING_RESULT_FAIL,
  payload: error,
})

export const fetchMLTraniningResults = (body) => {
  return async dispatch => {
    dispatch(fetchMltraningRes());
    axios.patch("/team/result/ml-traning", body)
      .then(function (response) {
        dispatch(fetchMltraningResSuccess(response.data.data));
      })
      .catch(function (error) {
        // console.log('error ----------------', error);
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(fetchMltraningResFail(JSON.stringify(error.response.data)));
        }
      });
  }
}


//fetch org teams
export const fetchOrgTeams = (body) => {
  return new Promise((resolve, reject) => {
    axios.patch("/team/organziatons/teams", body)
      .then(function (response) {
        resolve(response.data.data);
      })
      .catch(function (error) {
        reject(error);
      });
  })
}

// fetch all teams 
// Delete team members
const fetchallTeams = () => ({
  type: GET_TEAMS_LIST
})

const fetchallTeamsSuccess = items => ({
  type: GET_TEAMS_LIST_SUCCESS,
  payload: items,
})

const fetchallTeamsFail = error => ({
  type: GET_TEAMS_LIST_FAIL,
  payload: error,
})

export const fetchAllUserTeams = () => {
  return async dispatch => {
    dispatch(fetchallTeams());
    axios.get("/team/all-user-teams")
      .then(function (response) {
        // console.log('response :::: ', response.data.data)
        // console.log(JSON.stringify(response.data));
        dispatch(fetchallTeamsSuccess(response.data.data));
      })
      .catch(function (error) {
        // console.log('error ----------------', error);
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(fetchallTeamsFail(JSON.stringify(error.response.data)));
        }
      });

  }
}

export const fetchAllTeamsData = () => {
  return async dispatch => {
    dispatch(fetchallTeams());
    axios.patch("/team/all/list")
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        dispatch(fetchallTeamsSuccess(response.data.data));
      })
      .catch(function (error) {
        // console.log('error ----------------', error);
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(fetchallTeamsFail(JSON.stringify(error.response.data)));
        }
      });

  }
}


// fetch sims logs

// Delete team members
const fetchSimLogs = () => ({
  type: GET_SIMS_LOG
})

const fetchSimLogsSuccess = items => ({
  type: SIMS_LOG_SUCCESS,
  payload: items,
})

const fetchSimLogsFail = error => ({
  type: SIMS_LOG_FAIL,
  payload: error,
})

export const fethTeamSimLogs = (body) => {
  // console.log('body', body)
  return async dispatch => {
    dispatch(fetchSimLogs());
    axios.patch("/team/get/simlogs", body)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        dispatch(fetchSimLogsSuccess(response.data.data));
      })
      .catch(function (error) {
        // console.log('error ----------------', error);
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(fetchSimLogsFail(JSON.stringify(error.response.data)));
        }
      });

  }
}


export const setTeamAnylsisData = (items) => ({
  type: SET_TEAM_ANYLSIS_DATA,
  payload: items,
})



export const setTeamMpsData = (items) => ({
  type: SET_TEAM_MPS_DATA,
  payload: items,
})


// Delete team members
const removeTeamMembers = () => ({
  type: REMOVE_TEAM_MEMBERS
})

const removeTeamMembersSuccess = items => ({
  type: REMOVE_TEAM_MEMBERS_SUCC,
  payload: items,
})

const removeTeamMembersFail = error => ({
  type: REMOVE_TEAM_MEMBERS_FAIL,
  payload: error,
})

export const editTeamPlayers = (items) => {
  // console.log('items', items)
  return async dispatch => {
    dispatch(removeTeamMembers());
    try {
      await removePlayersFromTeam(items.deletePlayerList);
      dispatch(removeTeamMembersSuccess('Players removed Successfully'));
    } catch (error) {
      console.log('error', error)
      dispatch(removeTeamMembersFail(JSON.stringify(error)))
    }
  }
}

const removePlayersFromTeam = (players) => {
  return new Promise((resolve, reject) => {
    axios.put("/player/remove/teamplayer", { players, headers: { "Authorization": "***" } })
      .then(function (response) {
        //   console.log(JSON.stringify(response.data));
        resolve(response.data);
      })
      .catch(function (error) {
        //  console.log('error ----------------', error);
        reject(error.response.data);
      });
  })
}

export const getTeamSimulations = () => ({
  type: GET_TEAM_SIMULATIONS
})

export const resetTeamSimulations = () => ({
  type: RESET_TEAM_SIMULATIONS
})

export const getTeamSimulationsSuccess = items => ({
  type: GET_TEAM_SIMULATIONS_SUCCESS,
  payload: items,
})

const getTeamSimulationsFail = message => ({
  type: GET_TEAM_SIMULATIONS_FAIL,
  payload: message,
})


export const getAllSimulationsMps = () => ({
  type: GET_ALL_SIMULATIONS_MPS,
  payload: null,
})

const getAllSimulationsMpsSuccess = (items) => ({
  type: GET_ALL_SIMULATIONS_MPS_SUCC,
  payload: items,
})

const getAllSimulationsMpsFailed = (message) => ({
  type: GET_ALL_SIMULATIONS_MPS_FAIL,
  payload: message,
})


export const fetchTeamSimulations = (body) => {
  return dispatch => {
    dispatch(getTeamSimulations())
    const { teamPlayers } = body;
    if (!teamPlayers) return true
    axios.patch("/player/simulations-by-player-id", {
      teamPlayers: teamPlayers.filter((el) => el.users && el.users.length > 0).map((el) => el.users[0]._id),
      shortBy: "created_at",
      shortByOrder: -1
    })
      .then((response) => response.data.data)
      .then((response) => {
        const { simulations } = response
        dispatch(getTeamSimulationsSuccess(simulations || []))
        // const { players } = response
        // return _.flattenDeep(players.map((innerEl) => innerEl.sensor_details)).filter((el) => el)
      })
      .catch((e) => {
        console.log(e);
        dispatch(getTeamSimulationsFail(e.message))
      })
  }
}

export const fetchTeamSimulationsForMps = (body) => {
  return dispatch => {

    const { teamPlayers } = body;
    if (!teamPlayers) return true
    dispatch(getAllSimulationsMps())
    const filterPlayers = teamPlayers
      .filter((el) => el.users && el.users.length > 0)
      .map((el) => el.users[0]._id);
    axios
      .patch("/player/teamSimulationsForMps", {
        teamPlayers: filterPlayers,
        shortBy: "created_at",
        shortByOrder: -1
      })
      .then((response) => response.data.data)
      .then((response) => {
        const { simulations } = response;
        const simulationsData = simulations || [];

        if (simulationsData) {
          dispatch(getAllSimulationsMpsSuccess(simulationsData));
        }
      })
      .catch((e) => {
        console.log(e);
        dispatch(getAllSimulationsMpsFailed(e.message))
      });

  }
}


/**
 * Fetching  TEAM MEMBERS...
 */
const getTeamMembers = () => ({
  type: FETCH_TEAM_MEMBERS,
})

const getTeamMembersSuccess = (items) => ({
  type: FETCH_TEAM_MEMBERS_SUCCESS,
  payload: items
})

const getTeamMembersfFail = (err) => ({
  type: FETCH_TEAM_MEMBERS_FAIL,
  payload: err
})

export const fetchTeamMembers = (body) => {
  return dispatch => {
    dispatch(getTeamMembers());

    axios.patch("/team/get/members", body)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        dispatch(getTeamMembersSuccess(response.data.data));
      })
      .catch(function (error) {
        // console.log('error ----------------', error);
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(getTeamMembersfFail(JSON.stringify(error.response.data.message)));
        }
      });
  }
}
/* TEAM STATE SUMMARY DATA */

// GET ORG INS. LIST
export const getTeamSTatsSummary = (ins_id) => ({
  type: GET_TEAM_STAT_SUMMARY,
  payload: ins_id
})

const getTeamSTatsSummarySuccess = items => ({
  type: GET_TEAM_STAT_SUMMARY_SUCCESS,
  payload: items,
})

const getTeamSTatsSummaryFail = error => ({
  type: GET_TEAM_STAT_SUMMARY_FAIL,
  payload: error,
})

export const fetchTeamStatsSummaryData = (body) => {
  return dispatch => {
    dispatch(getTeamSTatsSummary());

    axios.patch("/team/stats/summary", body)
      .then(function (response) {
        dispatch(getTeamSTatsSummarySuccess(response.data.data));

      })
      .catch(function (error) {
        console.log('error ----------------', error);
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(getTeamSTatsSummaryFail(JSON.stringify(error.response.data.message)));
        }
      });
  }
}
// get top 20 strain============
// const fetchTeamTop20EventsData = () => ({
//   type: FETCH_TEAM_TOP_30_DATA
// })

// const fetchTeamTop20EventsSuccess = (payload) => ({
//   type: FETCH_TEAM_TOP_30_DATA_SUCCESS,
//   payload
// })

// const fetchTeamTop20EventsFail = (payload) => ({
//   type: FETCH_TEAM_TOP_30_DATA_FAIL,
//   payload
// })

export const fetchAllPlayerOptimizeAnalysis = (data) => {
  let id = data.id;
  let pressure_dashboard = data.pressure_dashboard ? data.pressure_dashboard : false;
  return dispatch => {
    dispatch(getAllPlayerAnalysisData())
    axios.get(`/team/allsummary-preview/${id}/${data.type}/${pressure_dashboard}`)
      .then((response) => response.data.data)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        // console.log("response", response)
        dispatch(getAllPlayerAnalysisDataSuccess(response));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        if (error.response && error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(getAllPlayerAnalysisDataFail(JSON.stringify(error.response.data)));
        }
      });
  }
}

// new analysis data for ml
const getAllPlayerMlAnalysisData = () => ({
  type: GET_ALL_PLAYER_ML_ANALYSIS_DATA
})

const getAllPlayerMlAnalysisDataSuccess = (payload) => ({
  type: GET_ALL_PLAYER_ML_ANALYSIS_DATA_SUCCESS,
  payload
})

const getAllPlayerMlAnalysisDataFail = (payload) => ({
  type: GET_ALL_PLAYER_ML_ANALYSIS_DATA_FAIL,
  payload
})

export const fetchAllPlayerOptimizeMlAnalysis = (data) => {
  let id = data.id;
  let pressure_dashboard = data.pressure_dashboard ? data.pressure_dashboard : false;
  return dispatch => {
    dispatch(getAllPlayerMlAnalysisData())
    axios.get(`/team/allMlsummary-preview/${id}/${data.type}/${pressure_dashboard}`)
      .then((response) => response.data.data)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        // console.log("response", response)
        dispatch(getAllPlayerMlAnalysisDataSuccess(response));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        if (error.response && error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(getAllPlayerMlAnalysisDataFail(JSON.stringify(error.response.data)));
        }
      });
  }
}
//
// new analysis data for pressure
const getAllPlayerPressureAnalysisData = () => ({
  type: GET_ALL_PLAYER_PRESSURE_ANALYSIS_DATA
})

const getAllPlayerPressureAnalysisDataSuccess = (payload) => ({
  type: GET_ALL_PLAYER_PRESSURE_ANALYSIS_DATA_SUCCESS,
  payload
})

const getAllPlayerPressureAnalysisDataFail = (payload) => ({
  type: GET_ALL_PLAYER_PRESSURE_ANALYSIS_DATA_FAIL,
  payload
})

export const fetchAllPlayerOptimizePressureAnalysis = (data) => {
  let id = data.id;
  let pressure_dashboard = data.pressure_dashboard ? data.pressure_dashboard : false;
  return dispatch => {
    dispatch(getAllPlayerPressureAnalysisData())
    axios.get(`/team/allpressuresummary-preview/${id}/${data.type}/${pressure_dashboard}`)
      .then((response) => response.data.data)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        // console.log("response", response)
        dispatch(getAllPlayerPressureAnalysisDataSuccess(response));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        if (error.response && error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(getAllPlayerPressureAnalysisDataFail(JSON.stringify(error.response.data)));
        }
      });
  }
}
// new analysis data end here
/* change admin to player*/
export const changeAdminToPlayer = (item) => ({
  type: CHANGE_ADMIN_TO_PLAYER,
  payload: item,
})
/* end */
/* Edit functionality for players */

// Delete Players...
export const deletePlayer = (item) => ({
  type: DELETE_PLAYERS,
  payload: item,
})

// status Players...
export const updateStatusPlayer = (item) => ({
  type: UPDATE_PLAYER_STATUS,
  payload: item,
})

// status All Players...
export const updateStatusAllPlayer = (item) => ({
  type: UPDATE_ALL_PLAYER_STATUS,
  payload: item,
})


// sensor id Players...
export const updatePlayerSensorId = (item) => ({
  type: UPDATE_SENSOR_ID,
  payload: item,
})



// edit -
const editPayers = () => ({
  type: EDIT_PLAYER
})

const editPayersState = (state) => ({
  type: EDIT_PLAYER_STATE,
  payload: state
})

const editPayersFail = (msg) => ({
  type: EDIT_PLAYER_FAIL,
  payload: msg
})

const editPayersSucc = (msg) => ({
  type: EDIT_PLAYER_SUCCESS,
  payload: msg
})

// Reseting all edit state ...
export const emptyPayersEditingState = () => ({
  type: EPMTY_EDITING_PLAYERS_DATA
})


// Make edit api calls ...
export const editPlayersData = (items) => {
  return async dispatch => {
    dispatch(editPayers());
    // console.log('items -----------------', items)
    // console.log('playerSensorIdList', items.changeAdminToPlayerList)
    try {
      //.team status id
      if (items.playerStatusList && items.playerStatusList.length > 0) {
        dispatch(editPayersState('Updating players team status...'));
        await updatedPlayerStatus(items.playerStatusList);
        dispatch(editPayersState('Players status updated'));
      }
      //.sensor id
      if (items.playerSensorIdList && items.playerSensorIdList.length > 0) {
        dispatch(editPayersState('Updating players sensor IDs...'));
        await updateSensorIds(items.playerSensorIdList);
        dispatch(editPayersState('Sensor IDs updated'));
      }
      //.delete
      if (items.deletePlayerList && items.deletePlayerList.length > 0) {
        dispatch(editPayersState('Deleting players...'));
        await deletePlayersTodb(items.deletePlayerList);
        dispatch(editPayersState('Players Deleted successfully'));
      }
      if (items.changeAdminToPlayerList && items.changeAdminToPlayerList.length > 0) {
        dispatch(editPayersState('changing admin to players...'));
        await changeAdminToPlayerTodb(items.changeAdminToPlayerList);
        dispatch(editPayersState('Admin change to player successfully'));
      }
      return dispatch(editPayersSucc('Successfully edited players.'))
    } catch (error) {
      //  console.log('catch err -------------------\n', error)
      if (error.response === undefined) return dispatch(editPayersFail('Network Error.'))
      if (error.response.data && error.response.data.message === "Invalid Token Input") {
        return dispatch(signOutUser())
      }
      return dispatch(editPayersFail(JSON.stringify(error.response)));
    }
  }
}
// Make call to convert admin to player ...
export const editAdminToPlayersData = (items) => {
  return async dispatch => {
    dispatch(editPayers());
    // console.log('items -----------------', items)
    // console.log('playerSensorIdListt', items.changeAdminToPlayerList)
    try {

      if (items.changeAdminToPlayerList && items.changeAdminToPlayerList.length > 0) {
        dispatch(editPayersState('changing admin to players...'));
        await changeAdminToPlayerTodb(items.changeAdminToPlayerList);
        dispatch(editPayersState('Admin change to player successfully'));
      }
      return dispatch(editPayersSucc('Admin change to player successfully'))
    } catch (error) {
      //  console.log('catch err -------------------\n', error)
      if (error.response === undefined) return dispatch(editPayersFail('Network Error.'))
      if (error.response.data && error.response.data.message === "Invalid Token Input") {
        return dispatch(signOutUser())
      }
      return dispatch(editPayersFail(JSON.stringify(error.response)));
    }
  }
}

const updateSensorIds = (players) => {
  return new Promise((resolve, reject) => {
    axios.put("/player/update/sensorId", { players })
      .then(function (response) {
        //   console.log(JSON.stringify(response.data));
        resolve(response.data);
      })
      .catch(function (error) {
        //  console.log('error ----------------', error);
        reject(error.response.data);
      });
  })
}

const updatedPlayerStatus = (players) => {
  return new Promise((resolve, reject) => {
    axios.put("/player/update/status", { players })
      .then(function (response) {
        //   console.log(JSON.stringify(response.data));
        resolve(response.data);
      })
      .catch(function (error) {
        //  console.log('error ----------------', error);
        reject(error.response.data);
      });
  })
}

const deletePlayersTodb = (players) => {
  return new Promise((resolve, reject) => {
    axios.delete("/player/deletes", { data: { players }, headers: { "Authorization": "***" } })
      .then(function (response) {
        //   console.log(JSON.stringify(response.data));
        resolve(response.data);
      })
      .catch(function (error) {
        //  console.log('error ----------------', error);
        reject(error.response.data);
      });
  })
}
const changeAdminToPlayerTodb = (user_id) => {
  return new Promise((resolve, reject) => {
    axios.patch("/admin/changetoplayer", { user_id })
      .then(function (response) {
        //   console.log(JSON.stringify(response.data));
        resolve(response.data);
      })
      .catch(function (error) {
        //  console.log('error ----------------', error);
        reject(error.response.data);
      });
  })
}
/* delete undefined admin memeber or player**/
const deleteUndefinedMemState = (msg) => ({
  type: DELETE_UNDEFINED_MEM_STATE,
  payload: msg
})

const deleteUndefinedMemloader = () => ({
  type: DELETE_UNDEFINED_MEM_LOADER
})

const deleteUndefinedMemFail = (msg) => ({
  type: DELETE_UNDEFINED_MEM_FAIL,
  payload: msg
})
export const deleteUndefinedMemberData = (items) => {
  return async dispatch => {
    dispatch(deleteUndefinedMemloader());
    // console.log('items -----------------', items)
    // console.log('deleteUndefinedMember', items.deleteUndefinedMember)
    try {

      if (items.deleteUndefinedMember && items.deleteUndefinedMember.length > 0) {
        dispatch(deleteUndefinedMemState('Undefined member deleting...'));
        await deleteUndefinedMemberFromdb(items.deleteUndefinedMember);
        dispatch(deleteUndefinedMemState('Undefined member deleted successfully'));
      }
    } catch (error) {
      //  console.log('catch err -------------------\n', error)
      if (error.response === undefined) return dispatch(deleteUndefinedMemFail('Network Error.'))
      if (error.response.data && error.response.data.message === "Invalid Token Input") {
        return dispatch(signOutUser())
      }
      return dispatch(deleteUndefinedMemFail(JSON.stringify(error.response)));
    }
  }
}
const deleteUndefinedMemberFromdb = (user_id) => {
  return new Promise((resolve, reject) => {
    axios.patch("/admin/deleteUndefinedMember", { user_id })
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        resolve(response.data);
      })
      .catch(function (error) {
        //  console.log('error ----------------', error);
        reject(error.response.data);
      });
  })
}

/* TEAM STAFF DELETE**/
const deleteTeamStaffState = (msg) => ({
  type: DELETE_TEAM_STAFF_STATE,
  payload: msg
})

const deleteTeamStaffloader = () => ({
  type: DELETE_TEAM_STAFF_LOADER
})
const deleteTeamStaffAfterSucc = () => ({
  type: DELETE_TEAM_STAFF_AFTER_SUCC
})

const deleteTeamStaffFail = (msg) => ({
  type: DELETE_TEAM_STAFF_FAIL,
  payload: msg
})
export const deleteTeamStaffData = (items) => {
  return async dispatch => {
    dispatch(deleteTeamStaffloader());
    // console.log('items -----------------', items)
    try {

      dispatch(deleteTeamStaffState('Team staff deleting...'));
        await deleteTeamStaffFromdb(items);
        dispatch(deleteTeamStaffState('Team staff deleted successfully'));
        setTimeout(() =>
          dispatch(deleteTeamStaffAfterSucc())
          , 1000)
    } catch (error) {
      //  console.log('catch err -------------------\n', error)
      if (error.response === undefined) return dispatch(deleteTeamStaffFail('Network Error.'))
      if (error.response.data && error.response.data.message === "Invalid Token Input") {
        return dispatch(signOutUser())
      }

      return dispatch(deleteTeamStaffFail(JSON.stringify(error.response)));
    }
  }
}
const deleteTeamStaffFromdb = (body) => {
  return new Promise((resolve, reject) => {
    axios.patch("/team/deleteTeamStaff", body)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        resolve(response.data);
      })
      .catch(function (error) {
        //  console.log('error ----------------', error);
        reject(error.response.data);
      });
  })
}

/*END HERE**/

/**
 * Edit functionality start here..
 * @returns 
 */

// add ...
export const addTeam = (ins) => ({
  type: ADD_TEAM,
  payload: ins,
})
// Rename ...
export const renameTeam = (item) => ({
  type: RENAME_TEAM,
  payload: item,
})
// Delete ...
export const deleteTeam = (item) => ({
  type: DELETS_TEAM,
  payload: item,
})
//merge ...
export const margeTeam = (item) => ({
  type: MERGE_TEAM,
  payload: item,
})

// edit -
const editTeam = () => ({
  type: EDIT_TEAM
})

const editState = (state) => ({
  type: EDIT_TEAM_STATE,
  payload: state
})

const editTeamFail = (msg) => ({
  type: EDIT_TEAM_FAIL,
  payload: msg
})

const editTeamSuccess = (msg) => ({
  type: EDIT_TEAM_SUCCESS,
  payload: msg
})

// Reseting all edit state ...

export const emptyTeamEditingState = () => ({
  type: EPMTY_EDITING_DATA
})


// Make edit api calls ...
export const editTeams = (items) => {
  return async dispatch => {
    dispatch(editTeam());
    // console.log('items -----------------', items)
    try {
      //.add
      /* if (items.addTeamName) {
        dispatch(editState('Adding Team...'));
        await addTeamTodb(items.addTeamName, items.institution_id, items.organization_id);
        dispatch(editState('Team added successfully.'));
      } */
      if (items.addList && items.addList.length > 0) {
        dispatch(editState('Adding Team...'));
        const addPromises = items.addList.map((el) => addTeamTodb(el, items.institution_id, items.organization_id))
        await Promise.all(addPromises)
        dispatch(editState('Team added successfully.'));
      }
      //.rename
      if (items.renameTeamList && items.renameTeamList.length > 0) {
        dispatch(editState('Updating Teams name...'));
        await renameTeamTodb(items.renameTeamList);
        dispatch(editState('Institutions Teams updated.'));

      }

      if (items.deleteTeamList && items.deleteTeamList.length > 0) {
        dispatch(editState('Deleting Teams...'));
        await deleteTeamTodb(items.deleteTeamList);
        dispatch(editState('Teams Deleted.'));
      }
      // // // merge
      if (items.mergeTeamList && items.mergeTeamList.length) {
        // console.log("mergeInsList", items.mergeTeamList);
        dispatch(editState('merging Teams...'));
        await mergeTeamTodb(items.mergeTeamList);
        dispatch(editState('Teams merged.'));
      }
      dispatch(editTeamSuccess('Successfully edited Teams.'))


    } catch (error) {
      //  console.log('catch err -------------------\n', error)
      if (error.response === undefined && (error.message === undefined || !error.message)) dispatch(editTeamFail('Network Error.'))
      if (error.response !== undefined && error.response.data !== undefined && error.response.data && error.response.data.message === "Invalid Token Input") {
        dispatch(signOutUser())
      }
      if (error.message !== undefined && error.message) {
        dispatch(editTeamFail(error.message))
      }
      // dispatch(editOrgFail(err.response));
    }
  }
}

const deleteTeamTodb = (teams) => {
  // console.log("ins", teams);
  return new Promise((resolve, reject) => {
    axios.delete("/team/delete", { data: { teams }, headers: { "Authorization": "***" } })
      .then(function (response) {
        //   console.log(JSON.stringify(response.data));
        resolve(response.data);
      })
      .catch(function (error) {
        //  console.log('error ----------------', error);
        reject(error.response.data);
      });
  })
}
const mergeTeamTodb = (teams) => {
  return new Promise((resolve, reject) => {
    axios.delete("/team/merge", { data: { }, headers: { "Authorization": "***" } })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        //  console.log('error ----------------', error);
        reject(error);
        // reject(error.response.data);
      });
  })
}
const renameTeamTodb = (teams) => {
  return new Promise((resolve, reject) => {
    axios.put("/team/rename", { teams })
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        resolve(response.data);
      })
      .catch(function (error) {
        // console.log('error ----------------', error);
        reject(error);
      });
  })
}

const addTeamTodb = (name, institution_id, organization_id) => {
  return new Promise((resolve, reject) => {
    axios.post("/team/add", { name: name, institution_id: institution_id, organization_id: organization_id })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error.response.data);
      });
  })
}

// GET ORG INS. LIST
const getInsTeamsList = (ins_id) => ({
  type: GET_INS_TEAMS_LIST,
  payload: ins_id
})

const getInsTeamsListSuccess = items => ({
  type: GET_INS_TEAMS_LIST_SUCCESS,
  payload: items,
})

const getInsTeamsListFail = error => ({
  type: GET_INS_TEAMS_LIST_FAIL,
  payload: error,
})


//previous code

// export const getInstitutionsTeams = (ins_id) => {
//   return dispatch => {
//     dispatch(getInsTeamsList(ins_id));

//     axios.patch("/team/getInsTeams", { 'ins_id': ins_id })
//       .then(function (response) {
//         // console.log(JSON.stringify(response.data));
//         dispatch(getInsTeamsListSuccess(response.data.data));

//       })
//       .catch(function (error) {
//         console.log('error ----------------', error);
//         if (error.response.data && error.response.data.message === "Invalid Token Input") {
//           dispatch(signOutUser())
//         } else {
//           dispatch(getInsTeamsListFail(JSON.stringify(error.response.data.message)));
//         }
//       });

//   }
// }

//newcode
export const getInstitutionsTeams = (ins_id) => {
  return dispatch => {
    dispatch(getInsTeamsList(ins_id));

    axios.get(`/institution/info/${ins_id}`)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        dispatch(getInsTeamsListSuccess(response.data.data));

      })
      .catch(function (error) {
        console.log('error ----------------', error);
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(getInsTeamsListFail(JSON.stringify(error.response.data.message)));
        }
      });

  }
}

const getTeamsByInsList = (ins_id) => ({
  type: GET_TEAMS_INS_LIST,
  payload: ins_id,
});

const getTeamsByInsListSuccess = (items) => ({
  type: GET_TEAMS_INS_LIST_SUCCESS,
  payload: items,
});

const getTeamsByInsListFail = (error) => ({
  type: GET_TEAMS_INS_LIST_FAIL,
  payload: error,
});

export const getTeamsByIns = (ins_id) => {
  return dispatch => {
    dispatch(getTeamsByInsList(ins_id));
    axios.patch("/team/getTeamsByInsId", { ins_id })
      .then(function (response) {
        // console.log('response.data.data :::::::', response.data.data)
        dispatch(getTeamsByInsListSuccess(response.data.data || []));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(getTeamsByInsListFail(JSON.stringify(error.response.data.message)));
        }
      });
  };
};
/**
 * Fetching Single team details by id...
 */
const teamById = () => ({
  type: TEAM_BYID,
})

const teamByIdSuccess = (items) => ({
  type: TEAM_BYID_SUCCESS,
  payload: items
})

const teamByIdFail = (err) => ({
  type: TEAM_BYID_FAIL,
  payload: err
})

export const getTeamDeatilsById = (body) => {
  return dispatch => {
    dispatch(teamById());
    axios.patch("/team/details/byId", body)
      .then(function (response) {
        dispatch(teamByIdSuccess(response.data.data));
      })
      .catch(function (error) {
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(teamByIdFail(JSON.stringify(error.response.data.message)));
        }
      });
  }
}
export const getSingleTeam = (body) => {
  return new Promise((resolve, reject) => {
    axios.patch("/team/single/Teams", body)
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      });
  })
}


/**
 * Fetching organization staff...
 */
const teamStaff = (state) => ({
  type: TEAM_STAFF,
})

const teamStaffSuccess = (items) => ({
  type: TEAM_STAFF_SUCCESS,
  payload: items
})

const teamStaffFail = (err) => ({
  type: TEAM_STAFF_FAIL,
  payload: err
})

export const getTeamStaffList = (body) => {
  return dispatch => {
    dispatch(teamStaff());

    axios.patch("/team/getStaffList", body)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        dispatch(teamStaffSuccess(response.data.data));
      })
      .catch(function (error) {
        // console.log('error ----------------', error);
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(teamStaffFail(JSON.stringify(error.response.data.message)));
        }
      });
  }
}
export const getMLplatformfiles = (body) => {
  return new Promise((resolve, reject) => {
    axios.post("/team/getMLplatformfiles", body)
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          reject("Invalid Token")
        } else {
          reject("Somthing wrong");
        }
      });
  })
}

export const getMLstatus = (body) => {
  return new Promise((resolve, reject) => {
    axios.post("/team/getMLstatus", body)
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          reject("Invalid Token")
        } else {
          console.log("error :::::::::::", error)
          reject("Somthing wrong");
        }
      });
  })
}
export const TeamStateScatterChart = (body) => {
  return new Promise((resolve, reject) => {
    axios.post("/team/TeamStateScatterChart", body)
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          reject("Invalid Token")
        } else {
          reject("Somthing wrong");
        }
      });
  })
}
export const TeamStateScatterChart_v1 = (body) => {
  return new Promise((resolve, reject) => {
    axios.post("/team/TeamStateScatterChart_v1", body)
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        if (error.response.data && error.response.data.message === "Invalid Token Input") {
          reject("Invalid Token")
        } else {
          reject("Somthing wrong");
        }
      });
  })
}
export const getteamplayerspositions = (body) => {
  return new Promise((resolve, reject) => {
    axios.post("/team/getteamplayerspositions", body)
      .then(function (response) {
        // console.log("response", response);
        resolve(response)
      })
      .catch(function (error) {
        console.log("error", error);
        if (error.response && error.response.data.message === "Invalid Token Input") {
          reject("Invalid Token")
        } else {
          reject("Somthing wrong");
        }
      });
  })
}

// Signout user if token invalid
const signOutUser = () => ({
  type: LOGOUT_LOGGEDIN_USER
})

/**
 * Update team jobs status ...
 */
export const updateTeamJobsStatus = (body) => {
  return new Promise((resolve, reject) => {
    axios.put("/team/updateStatus", body)
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        alert('Failed to upload! Somthing went wrong, please try again.')
      });
  })
}


/**
 * Calling upload jobs api ...
 */
export const uploadSingleJobFile = (body) => {
  return new Promise((resolve, reject) => {
    axios.post("/team/upload/singlJob", body)
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      });
  })
}

export const uploadSingleJobFile_v2 = (body) => {
  return new Promise((resolve, reject) => {
    axios.post(process.env.REACT_APP_simUploadApiEndpoint, body, {
      headers: {
        'x-api-key': process.env.REACT_APP_simUploadApiEndpointKey
      }
    })
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        //throw error
        console.log("error", error)
        reject(error)
      });
  })
}

export const uploadSingleJobFile_v3 = (body) => {
  return new Promise((resolve, reject) => {
    axios.post("/team/upload/singlb3Job", body)
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      });
  })
}

export const updateMeshType = (type) => ({
  type: MESH_TYPE,
  payload: type
})

export const updateInstanceType = (type) => ({
  type: INSTANCE_TYPE,
  payload: type
})
export const updatesavevtu = (type) => ({
  type: SAVE_VTU,
  payload: type
})

export const updateMeshSubType = (type) => ({
  type: MESH_SUBTYPE,
  payload: type
})

export const excludeExistingSimulation = (type) => ({
  type: EXCLUDE_SIMULATIONS,
  payload: type
})
export const existedSimulations = (type) => ({
  type: EXIST_SIMULATIONS,
  payload: type
})


export const jobUploadSuccess = (msg) => {
  return dispatch => {
    dispatch(UploadSuccess(msg))
    // setTimeout(() =>
    // dispatch(UploadSuccessRefresh(null))
    // , 1000)
    setTimeout(() =>
      dispatch(UploadSuccess(null))
      , 8000)
  }
}
export const UploadSuccessRefresh = (msg) => ({
  type: JOBS_UPLOAD_SUCCESS_AUTOREFRESH,
  payload: msg
})
export const UploadSuccess = (msg) => ({
  type: JOBS_UPLOAD_SUCCESS,
  payload: msg
})


// GET TEAM BRAIN IMAGE 
const getTeamImage = () => ({
  type: GET_TEAM_BRAIN_IMAGE,
})

const getTeamImageSuccess = items => ({
  type: GET_TEAM_BRAIN_IMAGE_SUCCESS,
  payload: items,
})

const getTeamImageFail = error => ({
  type: GET_TEAM_BRAIN_IMAGE_FAIL,
  payload: error,
})


export const getBrainImage = (team_id) => {
  return dispatch => {
    dispatch(getTeamImage());

    axios.get(`/team/getTeamBrainImage/${team_id}`)
      .then(function (response) {

        // console.log('response.data.data++++++++++++++++', response.data.data.brainImages)
        dispatch(getTeamImageSuccess(response.data.data.brainImages))
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        if (error.response && error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(getTeamImageFail(JSON.stringify(error.response.data)));
        }
      });

  }
}
// new analysis data for strain============
const getAllPlayerAnalysisData = () => ({
  type: GET_ALL_PLAYER_ANALYSIS_DATA
})

const getAllPlayerAnalysisDataSuccess = (payload) => ({
  type: GET_ALL_PLAYER_ANALYSIS_DATA_SUCCESS,
  payload
})

const getAllPlayerAnalysisDataFail = (payload) => ({
  type: GET_ALL_PLAYER_ANALYSIS_DATA_FAIL,
  payload
})
export const fetchTeamTop20Events = (data) => {
  let id = data.id;
  let pressure_dashboard = false
  return dispatch => {
    //dispatch(fetchTeamTop20EventsData())
    dispatch(getAllPlayerAnalysisData())
    
    axios.get(`/team/getTeamMpsData/${id}/${data.type}/${pressure_dashboard}`)
      .then((response) => response.data.data)
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        // console.log("response", response)
        // dispatch(fetchTeamTop20EventsSuccess(response));
        dispatch(getAllPlayerAnalysisDataSuccess(response));
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        if (error.response && error.response.data && error.response.data.message === "Invalid Token Input") {
          dispatch(signOutUser())
        } else {
          dispatch(getAllPlayerAnalysisDataFail(JSON.stringify(error.response.data)));
        }
      });
  }
}
//end ...


// fetch team sensors
const getTeamSensors = () => ({
  type: FETCH_TEAMS_SENSORS
})

const getTeamSensorsSuccess = (payload) => ({
  type: FETCH_TEAMS_SENSORS_SUCCESS,
  payload
})

const getTeamSensorsFail = (payload) => ({
  type: FETCH_TEAMS_SENSORS_FAIL,
  payload
})

export const fetchTeamSensors = (team_id) => {
  return dispatch => {
    dispatch(getTeamSensors())
    axios.get(`/sensor/team/${team_id}`)
      .then((response) => response.data.data)
      .then((response) => {
        dispatch(getTeamSensorsSuccess(response))
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const errorData = error?.response?.data;
        const payload =
          typeof errorData === "object"
            ? JSON.stringify(errorData)
            : errorData || error.message;

        if (errorData?.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          dispatch(getTeamSensorsFail(payload));
        }
      });
  }
}

const getBrainLoadOverTime = () => ({
  type: FETCH_BRAIN_LOAD_OVER_TIME
})

const getBrainLoadOverTimeSuccess = (payload) => ({
  type: FETCH_BRAIN_LOAD_OVER_TIME_SUCCESS,
  payload
})

const getBrainLoadOverTimeFail = (payload) => ({
  type: FETCH_BRAIN_LOAD_OVER_TIME_FAIL,
  payload
})

export const fetchBrainLoadOverTimeBasedOnSensorId = (sensor_id, team_id = null) => {
  return dispatch => {
    dispatch(getBrainLoadOverTime())
    let url = `/sensor/brain-load-over-time/${sensor_id}`
    if (team_id) {
      url += `?team_id=${team_id}`
    }
    axios.get(url)
      .then((response) => response.data.data)
      .then((response) => {
        dispatch(getBrainLoadOverTimeSuccess(response))
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const errorData = error?.response?.data;
        const payload =
          typeof errorData === "object"
            ? JSON.stringify(errorData)
            : errorData || error.message;

        if (errorData?.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          dispatch(getBrainLoadOverTimeFail(payload));
        }
      });
  }
}

// ASSESMENT SCORES

const getAssesmentScore = () => ({
  type: FETCH_ASSESMENT_SCORE
})

const getAssesmentScoreSuccess = (payload) => ({
  type: FETCH_ASSESMENT_SCORE_SUCCESS,
  payload
})

const getAssesmentScoreFail = (payload) => ({
  type: FETCH_ASSESMENT_SCORE_FAIL,
  payload
})

export const fetchAssesmentScore = (id = null, type = null, sensor_id = null) => {
  return dispatch => {
    dispatch(getAssesmentScore())
    let url = `/sensor/assesment-scores`
    if (id) url +=`/${id}`
    if (type) url +=`/${type}`
    if (sensor_id) url +=`/?filterId=${sensor_id}`
    // console.log('params', {
    //   id,
    //   type,
    //   sensor_id
    // })
    // console.log('URL >>> ', url)
    axios.get(url)
      .then((response) => response.data.data)
      .then((response) => {
        const { scores } = response
        if (scores) dispatch(getAssesmentScoreSuccess(scores))
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const errorData = error?.response?.data;
        const payload =
          typeof errorData === "object"
            ? JSON.stringify(errorData)
            : errorData || error.message;

        if (errorData?.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          dispatch(getAssesmentScoreFail(payload));
        }
      });
  }
}

const fetchTeams = () => ({
  type: FETCH_ALL_TEAMS
})

const fetchTeamsSuccess = items => ({
  type: FETCH_ALL_TEAMS_SUCCESS,
  payload: items,
})

const fetchTeamsFail = error => ({
  type: FETCH_ALL_TEAMS_FAIL,
  payload: error,
})

export const fetchAdminTeams = () => {
  return dispatch => {
    dispatch(fetchTeams())
    let url = `/team/items`
    axios.get(url)
      .then((response) => response.data.data)
      .then((response) => {
        // console.log('response >>> ', response)
        const { teams } = response
        if (teams) dispatch(fetchTeamsSuccess(teams))
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const errorData = error?.response?.data;
        const payload =
          typeof errorData === "object"
            ? JSON.stringify(errorData)
            : errorData || error.message;

        if (errorData?.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          dispatch(fetchTeamsFail(payload));
        }
      });
  }
}

// MPS assesment scores

const getMpsDataAnalytics = () => ({
  type: FETCH_MPS_DATA_ANALYTICS
})

const getMpsDataAnalyticsSuccess = (payload) => ({
  type: FETCH_MPS_DATA_ANALYTICS_SUCCESS,
  payload
})

const getMpsDataAnalyticsFail = (payload) => ({
  type: FETCH_MPS_DATA_ANALYTICS_FAIL,
  payload
})

export const fetchMpsDataAnalytics = (id = null, type = null, sensor_id = null) => {
  return dispatch => {
    dispatch(getMpsDataAnalytics())
    let url = `/sensor/analytics-assesment-mps`
    if (id) url +=`/${id}`
    if (type) url +=`/${type}`
    if (sensor_id) url +=`/?filterId=${sensor_id}`
    // console.log('params', {
    //   id,
    //   type,
    //   sensor_id
    // })
    // console.log('URL >>> ', url)
    axios.get(url)
      .then((response) => response.data.data)
      .then((response) => {
        const { assesmentPostImpact, assesmentBaseline } = response
        if (assesmentPostImpact && assesmentBaseline) {
          dispatch(getMpsDataAnalyticsSuccess({
            assesmentPostImpact,
            assesmentBaseline
          }))
        }
      })
      .catch(function (error) {
        console.log('error ----------------', error);
        const errorData = error?.response?.data;
        const payload =
          typeof errorData === "object"
            ? JSON.stringify(errorData)
            : errorData || error.message;

        if (errorData?.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          dispatch(getMpsDataAnalyticsFail(payload));
        }
      });
  }
}